<template>
  <div id="app">
    <index></index>
  </div>
</template>

<script>
import Index from "./views/index";

export default {
  name: "App",
  components: {
    Index,
  },
};
</script>

<style lang="scss">
#app {
  overflow: hidden;
  position: relative;
  margin-bottom: -30px;
}
</style>
